/* eslint-disable no-console */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef } from 'react';
import './realEstateAgent.css';

function RealEstateAgent() {
  const formRef = useRef();
  const [submitted, setSubmitted] = React.useState(false);
  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    let timeout;

    if (submitted || error) {
      timeout = setTimeout(() => {
        setSubmitted(false);
        setError(false);
      }, 5000);
    }

    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [submitted, error]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(formRef.current);

    try {
      await fetch(
        'https://docs.google.com/forms/d/e/1FAIpQLSdvQcFgRRtPcrwJo-NDY8zsUVwLhR_o4gqyGlmNbsnHKpvO2g/formResponse',
        {
          method: 'POST',
          mode: 'no-cors',
          body: formData,
        },
      );

      setSubmitted(true);
      setError(false);
      formRef.current.reset(); // optional: reset the form after submit
    } catch (error) {
      console.error('Form submission error:', error);
      setError(true);
      setSubmitted(false);
    }
  };

  return (
    <div className="english-agent-container">
      <div className="container">
        <div className="form-container">
          <h1 className="form-title">Real Estate Assistant Agent</h1>
          <div className="form-intro">
            <p>
              This agent is a
              <strong> DEMO </strong>
              product, designed specifically for USA Realtors who are looking to increase performance, lead the path in real estate AI innovation, and stand out by integrating AI-powered features into their website & digital strategy.  This service is provided in partnership with Zillow App.
            </p>

            <p>
              After submitting the form, this Real Estate AI agent will automatically do:
              <br />
              <br />
              <div className="ai-agent-steps">
                <p>✅ Evaluate the lead opportunity based on the details provided by the client.</p>
                <p>✅ Search for properties that match the lead`s preferences.</p>
                <p>
                  ✅ Analyze each property and score its market potential as
                  <strong> High</strong>
                  ,
                  <strong> Medium</strong>
                  , or
                  <strong> Low Market Interest</strong>
                  .
                </p>
                <p>✅ Send a personalized email to the lead with selected property findings and a link to book a meeting with you.</p>
              </div>
              <br />
              <strong>Please enter the email address where you`d like to receive this information.</strong>
            </p>

            <p>
              <i>
                *Each agent’s logic, design, and contextual training data can be fully tailored to meet the specific requirements of your application.
                <br />
                <br />
                **As the admin, you’re instantly notified of every user prompt, the AI-generated response, submitted contact information, and access to the full request history.
              </i>
            </p>

            <p>
              <strong>NOTE:</strong>
              If you`d like to learn more about offering this experience to your own clients or website visitors, you can book a meeting with me here:
              <a className="calendly" href="https://calendly.com/me-giojuliao/30min" target="_blank" rel="noopener noreferrer">Calendly.</a>
              <div>
                <a href="https://www.loom.com/share/bf8b4094481343349cc394f4c1db5768?sid=da4cf580-09e6-4957-9322-64c97f462676" target="_blank" rel="noopener noreferrer">
                  Watch the quick explainer video.
                </a>
                <br />
                <br />
                <a href="https://docs.google.com/spreadsheets/d/1TQwy5Wg-x8JLsCE70mm9cZr9tXqjVcNoXXtz1LXZJEM/edit?usp=sharing" target="_blank" rel="noopener noreferrer">
                  Watch Admin Lead Evaluation Sheet.
                </a>
              </div>
            </p>

            <p>
              <strong className="form-intro-warning">
                Important: This form response is for informational DEMO purposes only and should not be used without guidance from a qualified professional.
              </strong>
            </p>
          </div>

          <div className="required-note">
            <span className="required-symbol">*</span>
            indicates required field
          </div>

          <form className="form" onSubmit={handleSubmit} ref={formRef}>

            {/* Name Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="name"
                  name="entry.245531275"
                  required
                  className="form-input"
                  placeholder="John Doe"
                />
                <label htmlFor="name" className="select-label required">
                  name
                </label>
              </div>
            </div>

            {/* Email Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="email"
                  id="email"
                  name="entry.652682895"
                  required
                  className="form-input"
                  placeholder="tim@apple.com"
                />
                <label htmlFor="email" className="select-label required">
                  Email
                </label>
              </div>
            </div>

            {/* city Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="city"
                  name="entry.731407168"
                  className="form-input"
                  placeholder="San Francisco"
                />
                <label htmlFor="city" className="select-label required">
                  City
                </label>
              </div>
            </div>

            {/* state Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="state"
                  name="entry.830333770"
                  className="form-input"
                  placeholder="California"
                />
                <label htmlFor="state" className="select-label required">
                  State
                </label>
              </div>
            </div>

            {/* minBudget Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="minBudget"
                  name="entry.1975573950"
                  className="form-input"
                  placeholder="1000000"
                />
                <label htmlFor="minBudget" className="select-label required">
                  Min Budget
                </label>
              </div>
            </div>

            {/* maxBudget Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="maxBudget"
                  name="entry.2074858554"
                  className="form-input"
                  placeholder="2000000"
                />
                <label htmlFor="maxBudget" className="select-label required">
                  Max Budget
                </label>
              </div>
            </div>

            {/* beds Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="beds"
                  name="entry.794836782"
                  className="form-input"
                  placeholder="2"
                />
                <label htmlFor="beds" className="select-label required">
                  Bedrooms+
                </label>
              </div>
            </div>

            {/* baths Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="baths"
                  name="entry.1855825235"
                  className="form-input"
                  placeholder="2"
                />
                <label htmlFor="baths" className="select-label required">
                  Bathrooms+
                </label>
              </div>
            </div>

            {/* Apartment Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="apartment"
                  name="entry.1093721360"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select</option>
                  <option value="True">True</option>
                  <option value="False">False</option>
                </select>
                <label htmlFor="apartment" className="select-label required">
                  Could be apartment?
                </label>
              </div>
            </div>

            {/* Condo Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="condo"
                  name="entry.1114225998"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select</option>
                  <option value="True">True</option>
                  <option value="False">False</option>
                </select>
                <label htmlFor="condo" className="select-label required">
                  Could be condo?
                </label>
              </div>
            </div>

            {/* townHouse Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="townhouse"
                  name="entry.1106075228"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select</option>
                  <option value="True">True</option>
                  <option value="False">False</option>
                </select>
                <label htmlFor="townhouse" className="select-label required">
                  Could be Town House?
                </label>
              </div>
            </div>

            {/* lotLand Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="lotland"
                  name="entry.1612755045"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select</option>
                  <option value="True">True</option>
                  <option value="False">False</option>
                </select>
                <label htmlFor="lotland" className="select-label required">
                  Could be a Lot Land?
                </label>
              </div>
            </div>

            {/* garage Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="garage"
                  name="entry.1116814900"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select</option>
                  <option value="True">True</option>
                  <option value="False">False</option>
                </select>
                <label htmlFor="garage" className="select-label required">
                  Garage?
                </label>
              </div>
            </div>

            {/* yearBuilt&After Field */}
            <div className="form-group">
              <div className="input-container">
                <input
                  type="text"
                  id="yearBuilt&After"
                  name="entry.1615876530"
                  className="form-input"
                  placeholder="2010"
                />
                <label htmlFor="yearBuilt&After" className="select-label required">
                  Year Built and After?
                </label>
              </div>
            </div>

            {/* timeline Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="timeLine"
                  name="entry.1761447811"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select</option>
                  <option value="1-3 Months">1-3 Months</option>
                  <option value="3-6 Months">3-6 Months</option>
                  <option value="6+ Months">6+ Months</option>
                </select>
                <label htmlFor="timeLine" className="select-label required">
                  Timeline?
                </label>
              </div>
            </div>

            {/* mortgage Field */}
            <div className="form-group">
              <div className="select-container">
                <select
                  id="mortgage"
                  name="entry.1654448331"
                  required
                  className="form-select"
                  defaultValue=""
                >
                  <option value="" disabled>Select</option>
                  <option value="True">True</option>
                  <option value="False">False</option>
                </select>
                <label htmlFor="mortgage" className="select-label required">
                  Mortgage?
                </label>
              </div>
            </div>

            {/* Submit Button */}
            <div className="required-note consent">
              <span className="required-symbol">*</span>
              <p>By submitting this form, you agree to be contacted via email with your personalized content and occasional updates related to this service.</p>
            </div>
            <div className="button-container">
              <button
                type="submit"
                className="submit-button"
              >
                Submit
              </button>
              <div className="submit-button-response">
                {submitted && (
                  <div className="form-success-message">
                    🎉 Thanks! Your response has been submitted.
                  </div>
                )}

                {error && (
                <div className="form-error-message">
                  ❌ Oops! Something went wrong. Please try again in a few seconds.
                </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default RealEstateAgent;
